var _alerts = (function(w) {
	var _alert = function(obj) {
		var _setting = {
			time : 3000,
			title : false,
			desc : false,
			button: false,
			buttonSecond: false,
			click : false,
			clickBtn1: false,
			clickBtn2: false,
			typeMess: "done",
			onclose: false,
		};
		var gal = '<figure class="success"><svg viewBox="0 0 20 20" class="done"><polyline points="4 11 8 15 16 6" class="done"></polyline></svg></figure>';
		var galError = '<figure class="error"><svg viewBox="0 0 16 16" class="error"><line x1="4" y1="4" x2="12" y2="12" class="error"></line><line x1="12" y1="4" x2="4" y2="12" class="error"></line></svg></figure>';
		// --- оброботка данных//
		if(typeof(obj) == "object") {
			for(var key in obj) {
				if(typeof(_setting[key]) != "undefined") {
					if(typeof(obj[key]) != "object") {
						_setting[key] = obj[key];
					} else {
						for(key_ in obj[key]) {
							if(typeof(_setting[key][key_]) != "undefined") {
								_setting[key][key_] = obj[key][key_];
							}
						}
					}
				}
			}
		}
		// --- Функции
		var fn = {
			close : function() {
				_el.classList.add("close");
				_el.classList.remove("open");
				setTimeout(function(el) {
					//if(typeof(el.parentNode)!=="undefined" && el.parentNode!=null) {
						//document.body.removeChild(el);
						el.parentNode.removeChild(el);
						if(_setting.onclose) {
							_setting.onclose.apply(el);
						}
					//}
				}, 1500, _el);
				return false;
			},
			open : function() {
				_el.classList.add("start");
			}
		};
		// --- Создания елемента
		var _el = document.createElement("div");
		_el.className = "_alert";
		
		var _content = document.createElement("div");
		_content.className = "_alert-content";
		if(_setting.typeMess == "done") {
			_content.innerHTML = gal;
		} else if(_setting.typeMess == "error") {
			_content.innerHTML = galError;
		}

		if(_setting.title != false) {
			var _title = document.createElement("span");
				_title.innerText = _setting.title;
				_content.appendChild(_title);
		}
		if(_setting.desc != false) {
			var _desc = document.createElement("p");
				_desc.innerText = _setting.desc;
				_content.appendChild(_desc);
		}
		if(_setting.button != false) {
			var _button = document.createElement("button");
				if(_setting.buttonSecond != false){
					_button.className = "aButtonFirst";
				} else {
					_button.className = "aButton";
				}
				_button.innerText = _setting.button;
				if(typeof _setting.click == "function"){
					_button.onclick = _setting.click;
				} else if(typeof _setting.clickBtn1 == "function"){
					_button.onclick = _setting.clickBtn1;
				}
				_button.addEventListener("click",fn.close);
				_content.appendChild(_button);
		}
		if(_setting.buttonSecond != false) {
			var _button = document.createElement("button");
				_button.className = "aButtonSecond";
				_button.innerText = _setting.buttonSecond;
				if(typeof _setting.click == "function"){
					_button.onclick = _setting.click;
				} else if(typeof _setting.clickBtn2 == "function"){
					_button.onclick = _setting.clickBtn2;
				}
				_button.addEventListener("click", fn.close);
				_content.appendChild(_button);
		}
		
		_el.appendChild(_content);

		var prev = document.querySelectorAll("._alert");
		for(var i=0; i<prev.length; i++) {
			document.body.removeChild(prev[i]);
		}

		document.body.appendChild(_el);
		
		var height = _content.offsetHeight;
		if(height < (window.innerHeight - 30)) {
			height = (window.innerHeight-height)/2;
			_content.style.marginTop = height+"px";
		} else {
			_content.style.marginTop = "50px";
		}
		
		_el.classList.add("open")
		
		//setTimeout(fn.open,200);
		
		if(_setting.button == false) {
			setTimeout(fn.close, _setting.time);
		}
		console.warn("test");
	}
	w._alert = _alert;
	return _alert;
})(window);

export const alert = _alerts;